import React from 'react';
import styles from './Dock.module.css';
import { MACOS_DOCK_HEIGHT_PX } from '../../../constants';

interface DockApp {
  id: string;
  label: string;
  iconSrc: string;
}

const DOCK_APPS: DockApp[] = [
  { id: 'finder',   label: 'Finder',   iconSrc: '/assets/finder.png' },
  { id: 'safari',   label: 'Safari',   iconSrc: '/assets/safari.png' },
  { id: 'mail',     label: 'Mail',     iconSrc: '/assets/mail.png' },
  { id: 'photos',   label: 'Photos',   iconSrc: '/assets/photos.png' },
  { id: 'music',    label: 'Music',    iconSrc: '/assets/music.png' },
];

const ICON_SIZE = 52;  // logical px — fits within 70px dock height with padding

export function Dock() {
  return (
    <div
      className={styles.dockShell}
      style={{ height: MACOS_DOCK_HEIGHT_PX }}
    >
      <div className={styles.dockPill} role="toolbar" aria-label="Dock">
        {DOCK_APPS.map((app) => (
          <div key={app.id} className={styles.appSlot}>
            <img
              src={app.iconSrc}
              alt={app.label}
              className={styles.icon}
              style={{ width: ICON_SIZE, height: ICON_SIZE }}
              role="button"
              aria-label={app.label}
              tabIndex={-1}
              draggable={false}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
